import React from 'react';
import { BookOpenIcon, GiftIcon, CheckIcon, GlobeIcon, TrophyIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
import { images } from '../data/links';
import { offerVolumes, offerBonuses, offerPerks } from '../data/content';
export function Offer() {
  return <section id="offer" className="bg-paper px-4 py-16 md:px-5 md:py-24" aria-labelledby="offer-title" data-id="element-236" data-mp="1hqs749kvfpl4">
      <div className="mx-auto max-w-6xl" data-id="element-237" data-mp="ozs0dqv5o7pr">
        <div className="mx-auto max-w-3xl text-center" data-id="element-238" data-mp="p0tk0jq8m2j3">
          <p className="inline-flex items-center gap-2 rounded-full bg-gold px-4 py-1.5 text-sm font-black uppercase text-ink" data-id="element-239" data-mp="13x165pl7he10">
            <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-240" data-mp="yxohczarxwvs" />
            Special Launch Offer
          </p>
          <h2 id="offer-title" className="mt-4 font-display text-3xl font-black leading-tight text-ink md:text-5xl" data-id="element-241" data-mp="2fb4uog90y9yo">
            Here’s Everything You’ll Receive Today
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[1.1fr_1fr] lg:items-start" data-id="element-242" data-mp="pj5ucnay2gdh">
          <div className="rounded-3xl bg-white p-5 md:p-8" data-id="element-243" data-mp="uiiqjynpgzsq">
            <img src={images.mockup} alt="Everything included in TRT Blueprint" className="mx-auto w-full max-w-md" loading="lazy" data-id="element-244" data-mp="ul4y3yaljfay" />

            <div className="mt-6 border-t border-slate-200 pt-6" data-id="element-245" data-mp="13ki4gi3fbnrg">
              <div className="flex items-start justify-between gap-3" data-id="element-246" data-mp="13hnn4zfpij29">
                <h3 className="flex items-center gap-2 font-display text-lg font-black text-ink" data-id="element-247" data-mp="6vkcf7n263xz">
                  <BookOpenIcon className="h-5 w-5 shrink-0 text-brandDark" aria-hidden="true" data-id="element-248" data-mp="bt2bm6b9x4ss" />
                  TRT Blueprint™ — The Complete Six-Volume Collection
                </h3>
                <s className="shrink-0 font-bold text-slate-400" data-id="element-249" data-mp="klxgv00qr0ik">$97</s>
              </div>
              <ul className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-250" data-mp="3k7ugofkofrrl">
                {offerVolumes.map(item => <li key={item} className="flex gap-2 text-slate-700" data-id="element-251" data-mp="3o8eelld2qzes">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-252" data-mp="vepbv4sad9wr" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="mt-6 border-t border-slate-200 pt-6" data-id="element-253" data-mp="1550qbl9lj1hw">
              <div className="flex items-start justify-between gap-3" data-id="element-254" data-mp="10678xhr6uqcg">
                <h3 className="flex items-center gap-2 font-display text-lg font-black text-ink" data-id="element-255" data-mp="cgv5yzmgfeil">
                  <GiftIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-256" data-mp="7hrzdaqtt08i" />
                  Five Exclusive Professional Bonuses
                </h3>
                <s className="shrink-0 font-bold text-slate-400" data-id="element-257" data-mp="lj49v6n7w9n0">$175</s>
              </div>
              <ul className="mt-3 space-y-2" data-id="element-258" data-mp="heehhrrrpd6u">
                {offerBonuses.map(item => <li key={item} className="flex gap-2 text-slate-700" data-id="element-259" data-mp="1wvf0b6ehntoa">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-260" data-mp="1svwdg533x8it" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="rounded-3xl border-4 border-cta bg-white p-5 text-center md:p-8 lg:sticky lg:top-6" data-id="element-261" data-mp="25fbh7m99p7tn">
            <p className="text-sm font-bold uppercase tracking-wide text-slate-500" data-id="element-262" data-mp="1qianxebfh4t2">Total reference value</p>
            <p className="font-display text-3xl font-black text-alert line-through decoration-4" data-id="element-263" data-mp="1vhncq4lv0lya">$272</p>
            <p className="mt-4 font-display text-lg font-extrabold uppercase text-ink" data-id="element-264" data-mp="2j7hmueesnweu">Today, get everything for just…</p>
            <p className="mt-1 font-display font-black leading-none text-cta" data-id="element-265" data-mp="29fll8tdi1o5v">
              <span className="align-top text-4xl" data-id="element-266" data-mp="29dhjagz5uz88">$</span>
              <span className="text-[96px] md:text-[120px]" data-id="element-267" data-mp="2ed3xasmtcji3">27</span>
              <span className="ml-1 text-2xl text-ink" data-id="element-268" data-mp="323hh5vv8vc1l">USD</span>
            </p>
            <p className="mt-2 font-semibold text-slate-600" data-id="element-269" data-mp="36upuh2zp3hk1">One-time payment. No monthly fees.</p>

            <p className="mx-auto mt-4 flex max-w-sm items-center justify-center gap-2 rounded-xl bg-blue-50 px-3 py-2.5 text-sm font-semibold text-navy" data-id="element-270" data-mp="1j6ed2ijsuow6">
              <GlobeIcon className="h-4 w-4 shrink-0 text-brandDark" aria-hidden="true" data-id="element-271" data-mp="1e5qhdjkmljvm" />
              Currency conversion is automatic — you’ll pay in your local currency.
            </p>

            <ul className="mx-auto mt-5 max-w-sm space-y-2 text-left" data-id="element-272" data-mp="14af8hhvwf6vs">
              {offerPerks.map(perk => <li key={perk} className="flex gap-2 font-medium text-slate-700" data-id="element-273" data-mp="21w4896rh5com">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-274" data-mp="1wz46h81nqw3b" />
                  {perk}
                </li>)}
            </ul>

            <div className="mt-7 flex flex-col items-center gap-4" data-id="element-275" data-mp="1n6y9tl0gnqhs">
              <CTAButton label="Get TRT Blueprint for $27" data-id="element-276" data-mp="2kn3vo3jbmefs" />
              <Countdown data-id="element-277" data-mp="2kpgk8zjl3n1t" />
              <ScarcityBar data-id="element-278" data-mp="2fwnce2stjyli" />
            </div>

            <p className="mt-5 text-sm leading-relaxed text-slate-600" data-id="element-279" data-mp="2fvvl34698n11">
              For $27, you’ll have an organized TRT educational reference collection you can revisit whenever you need to review the relevant clinical considerations.
            </p>
            <p className="mt-4 text-xs text-slate-400" data-id="element-280" data-mp="2x697vsosfyit">
              The reference values represent positioning estimates, not independently verified retail prices.
            </p>
          </div>
        </div>
      </div>
    </section>;
}